 function showMessage(){
      let params = new URLSearchParams(window.location.search);
      let quotation = params.get("quotation");
      let order = params.get("order");
      if(parseInt(quotation)){
        $(".quote-event").html("Thank you for submitting your quote");
        $(".banner-info").show();
      }
    if(parseInt(order)){
        $(".quote-event").html("Thank you for requesting a quote");
        $(".banner-info").show();
      }
  }

  $(document).ready(function(){
    showMessage();
  });